export function findRefByName(refName: string, base: any) {
    let obj = base
    while (obj) {
        if ( (obj as any).$refs[refName]) {
            return obj.$refs[refName]
        }
        obj = obj.$parent
    }
    return undefined
}


export function findConfirmDialogRef(base: any) {
    return findRefByName("confirmDlg", base);
}

export function findConfirmUserDialogRef(base: any) {
    return findRefByName("confirmDlgUser", base);
}

export function findConfirmBlackBoardsDialogRef(base: any) {
    return findRefByName("confirmDlgBlackBoards", base);
}